module.exports = __webpack_public_path__ + "static/ar-logo-c9a965b43ac7944f2670199cc6e6220f.png";